import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBasketTrackerSection} from '../hooks/useGetBasketPageSection';
import {BasketTracketView} from './BasketTrackerView';

export const BasketTracker = () => {
  const request = useBasketTrackerSection();

  return (
    <DataFetcher
      request={request}
      View={BasketTracketView}
      Error={() => null}
      viewProps={{isDataFetching: request.isFetching}}
    />
  );
};
